export interface GkComment {
  nickname: string;
  role: string;
  avatarText: string;
  text: string;
  meta: string;
  accent: string;
}

export const gkComments: GkComment[] = [
  {
    nickname: "爱追剧的桃子",
    role: "影迷·关注两年",
    avatarText: "桃",
    text: "每天睡醒第一件事就是来扫一眼今日新瓜，这个栏目对我这种重度冲浪选手太友好了，最新爆料基本都是当天的，速度真的快。",
    meta: "每日必读",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    nickname: "不吃瓜睡不着",
    role: "综艺爱好者",
    avatarText: "瓜",
    text: "最爱综艺现场栏目，很多名场面我都是在这儿看懂的，编辑的点评也很到位，看完还能get到新梗。",
    meta: "栏目好评",
    accent: "bg-accent-100 text-accent-800",
  },
  {
    nickname: "五点下班阿黎",
    role: "上班族·晚八点档",
    avatarText: "黎",
    text: "下班路上刷新鲜瓜速递已经是习惯了，更新准时、内容干净，不搞标题党，这点必须点赞。",
    meta: "准时更新",
    accent: "bg-secondary-100 text-secondary-800",
  },
  {
    nickname: "西瓜籽",
    role: "社交热榜常客",
    avatarText: "籽",
    text: "社交热榜的解读很走心，不只讲八卦还会聊现象背后的东西，比单纯刷热搜有意思多了。",
    meta: "有深度",
    accent: "bg-primary-100 text-primary-700",
  },
];